import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@src/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-TW'
// 由於滾動條隱藏和出現導致頁面抖動問題的解決
ElementUI.Dialog.props.lockScroll.default = false;
Vue.use(ElementUI, { locale });
